import { useState } from 'react';

export default (initValue = 0) => {
  const [value, setValue] = useState(initValue);

  const onChange = e =>
    setValue(parseInt(e.target.value.replace(/\D/g, ''), 10) || 0);

  return [value, onChange, setValue];
};
